import React from "react";
import { Outlet } from "react-router-dom";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";

const ApplicationsOutlet = () => {
  useCrumb("/applications/", {
    to: `/applications`,
    text: "Applications",
  });

  return <Outlet />;
};

export default ApplicationsOutlet;
